import registerHBModal from '../shared/custom-elements/hb-modal';
import { initAutoComplete } from '../shared/instances/autocomplete';
import { initCountrySwitcher } from '../shared/instances/country-switcher';
import { initDomainMismatchNudge } from '../shared/instances/domain-mismatch-nudge';
import { initGtmTracking } from '../shared/instances/gtm-tracking';
import { initHeaderBingoLink } from '../shared/instances/header-bingo-link';
import { initBuyNowPayLaterModal } from '../shared/instances/hobbii-modal';
import { initHobbiiStarter } from '../shared/instances/hobbii-starter';
import { initNewsletterSignupForm } from '../shared/instances/newsletter-signup-form';
import { initNotifications } from '../shared/instances/notifications';
import { initStickyHeader } from '../shared/instances/sticky-header';
import { initTocVerification } from '../shared/instances/toc-verification';
import { attachNativePredictiveClickTracking } from '../shared/tracking/native-predictive-tracking';

// Bind once here (not in relewise.ts): common.ts loads on every layout incl.
// simple.liquid, and the listener is a no-op on the Relewise arm (matches only
// .js-predictive-result). Not flag-gated, so the first paint is covered.
const bindNativePredictiveClickTracking = () => {
  attachNativePredictiveClickTracking();
};
if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    bindNativePredictiveClickTracking
  );
} else {
  bindNativePredictiveClickTracking();
}

registerHBModal();
initHobbiiStarter();
initNotifications();
initTocVerification();
initBuyNowPayLaterModal();
initAutoComplete();
initNewsletterSignupForm();
initStickyHeader();
initCountrySwitcher();
initDomainMismatchNudge();
initGtmTracking();
initHeaderBingoLink();
